import * as React from 'react'
import { ProductTeaserItem } from './Item'
import { Headline } from '../../components/UI'
import { useTranslation } from '../../lib/context/i18n'
import { StyledListContainer, StyledUsedProductsContainer } from './styled'
import { ProductTeaserProps } from './types'
import { sbEditable } from '@storyblok/storyblok-editable'

export const ProductTeaser = ({ usedProducts, blok }: ProductTeaserProps) => {
  const translations = useTranslation()

  if (blok) {
    return (
      <StyledUsedProductsContainer {...sbEditable(blok)}>
        <Headline is={blok.headlineSyntax}>{blok.headline}</Headline>
        <StyledListContainer>
          {blok.products.map(product => (
            <ProductTeaserItem product={product} />
          ))}
        </StyledListContainer>
      </StyledUsedProductsContainer>
    )
  }

  return (
    <StyledUsedProductsContainer>
      <Headline is="h6">{translations('general_ProductsForThisCase')}</Headline>
      <StyledListContainer>
        {usedProducts.map(product => (
          <ProductTeaserItem product={product} />
        ))}
      </StyledListContainer>
    </StyledUsedProductsContainer>
  )
}
